import roller from 'common/module/ui/roller';

import applicationBootstrap from 'website/bootstrap';
import filterList from 'website/containers/lists/filterlist';
import initPlayer from 'website/module/player';
import dropdownLinks from 'website/module/ui/dropdown-custom';
import facebookWidgets from 'website/module/ui/facebookWidgets';
import selectChange from 'website/module/ui/select-change';
import thirdNav from 'website/module/ui/third-nav';

// bootstrap the application / store
applicationBootstrap().then(() => {
  initPlayer();

  thirdNav();

  roller();

  dropdownLinks();

  filterList();

  selectChange();

  facebookWidgets();
});
